import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";
import TableContainer from "@material-ui/core/TableContainer";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import { WhatsappsFilter } from "../../components/WhatsappsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import { ArrowDropDown, Backup, ContactPhone } from "@material-ui/icons";
import { Menu, MenuItem } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import ContactBatchWalletModal from "../../components/ContactBatchWalletModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import ContactWalletInfo from "../../components/ContactWalletInfo";
import ContactWalletField from "../../components/ContactWalletField";
import RowActionsMenu from "../../components/RowActionsMenu";
import AppliedFiltersBar from "../../components/AppliedFiltersBar";
import FilterButton from "../../components/FilterButton";
import FilterPopover from "../../components/FilterPopover";
import MetricsStrip from "../../components/MetricsStrip";
import {
  buildContactWalletPayload,
  hasContactWalletMetadata,
  isNoContactPermissionError,
} from "../../utils/contactWallet";
import { buildContactsQueryParams } from "../../utils/contactListQueryParams";

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";

// ================= GEO / DDD CONFIG DO MAPA =================

const geoUrl =
  "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const markers = [
  { markerOffset: -30, name: "Aracaju", coordinates: [-37.0717, -10.9472] },
  { markerOffset: 15, name: "Belém", coordinates: [-48.4878, -1.4558] },
  { markerOffset: 15, name: "Belo Horizonte", coordinates: [-43.9378, -19.8157] },
  { markerOffset: 15, name: "Boa Vista", coordinates: [-60.6739, 2.8195] },
  { markerOffset: 15, name: "Brasília", coordinates: [-47.8825, -15.7942] },
  { markerOffset: 15, name: "Campo Grande", coordinates: [-54.6464, -20.4428] },
  { markerOffset: 15, name: "Cuiabá", coordinates: [-56.0969, -15.6011] },
  { markerOffset: 15, name: "Curitiba", coordinates: [-49.2736, -25.4296] },
  { markerOffset: 15, name: "Florianópolis", coordinates: [-48.5492, -27.5969] },
  { markerOffset: 15, name: "Fortaleza", coordinates: [-38.5267, -3.71839] },
  { markerOffset: 15, name: "Goiânia", coordinates: [-49.2736, -16.6869] },
  { markerOffset: 15, name: "João Pessoa", coordinates: [-34.8631, -7.1195] },
  { markerOffset: 15, name: "Macapá", coordinates: [-51.0667, 0.0333] },
  { markerOffset: 15, name: "Maceió", coordinates: [-35.7353, -9.6658] },
  { markerOffset: 15, name: "Manaus", coordinates: [-60.025, -3.10194] },
  { markerOffset: 15, name: "Natal", coordinates: [-35.2094, -5.795] },
  { markerOffset: 15, name: "Palmas", coordinates: [-48.3347, -10.1844] },
  { markerOffset: 15, name: "Porto Alegre", coordinates: [-51.23, -30.0331] },
  { markerOffset: 15, name: "Porto Velho", coordinates: [-63.9039, -8.7619] },
  { markerOffset: 15, name: "Recife", coordinates: [-34.8811, -8.05389] },
  { markerOffset: 15, name: "Rio Branco", coordinates: [-67.8099, -9.9747] },
  { markerOffset: 15, name: "Rio de Janeiro", coordinates: [-43.1729, -22.9068] },
  { markerOffset: 15, name: "Salvador", coordinates: [-38.4813, -12.9716] },
  { markerOffset: 15, name: "São Luís", coordinates: [-44.3028, -2.5283] },
  { markerOffset: 15, name: "São Paulo", coordinates: [-46.6333, -23.5505] },
  { markerOffset: 15, name: "Teresina", coordinates: [-42.8039, -5.0892] },
  { markerOffset: 15, name: "Vitória", coordinates: [-40.3378, -20.3194] },
];

const dddList = {
  "11": "São Paulo",
  "12": "São Paulo",
  "13": "São Paulo",
  "14": "São Paulo",
  "15": "São Paulo",
  "16": "São Paulo",
  "17": "São Paulo",
  "18": "São Paulo",
  "19": "São Paulo",
  "21": "Rio de Janeiro",
  "22": "Rio de Janeiro",
  "24": "Rio de Janeiro",
  "27": "Espírito Santo",
  "28": "Espírito Santo",
  "31": "Minas Gerais",
  "32": "Minas Gerais",
  "33": "Minas Gerais",
  "34": "Minas Gerais",
  "35": "Minas Gerais",
  "37": "Minas Gerais",
  "38": "Minas Gerais",
  "41": "Paraná",
  "42": "Paraná",
  "43": "Paraná",
  "44": "Paraná",
  "45": "Paraná",
  "46": "Paraná",
  "47": "Santa Catarina",
  "48": "Santa Catarina",
  "49": "Santa Catarina",
  "51": "Rio Grande do Sul",
  "53": "Rio Grande do Sul",
  "54": "Rio Grande do Sul",
  "55": "Rio Grande do Sul",
  "61": "Distrito Federal/Goiás",
  "62": "Goiás",
  "63": "Tocantins",
  "64": "Goiás",
  "65": "Mato Grosso",
  "66": "Mato Grosso",
  "67": "Mato Grosso do Sul",
  "68": "Acre",
  "69": "Rondônia",
  "71": "Bahia",
  "73": "Bahia",
  "74": "Bahia",
  "75": "Bahia",
  "77": "Bahia",
  "79": "Sergipe",
  "81": "Pernambuco",
  "82": "Alagoas",
  "83": "Paraíba",
  "84": "Rio Grande do Norte",
  "85": "Ceará",
  "86": "Piauí",
  "87": "Pernambuco",
  "88": "Ceará",
  "89": "Piauí",
  "91": "Pará",
  "92": "Amazonas",
  "93": "Pará",
  "94": "Pará",
  "95": "Roraima",
  "96": "Amapá",
  "97": "Amazonas",
  "98": "Maranhão",
  "99": "Maranhão",
};

const CONTACT_WALLET_STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "assigned", label: "Com carteira" },
  { value: "unassigned", label: "Sem carteira" },
];

const buildContactsSummary = (contacts = []) => {
  const active = contacts.filter((contact) => contact.active).length;
  const blocked = contacts.length - active;
  const withWallet = contacts.filter((contact) =>
    hasContactWalletMetadata(contact)
  ).length;

  return {
    active,
    blocked,
    withWallet,
  };
};

// ================= REDUCER =================

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    minWidth: 0,
  },
  contentStack: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    width: "100%",
    minWidth: 0,
  },
  mainPaper: {
    flex: 1,
    width: "100%",
    minWidth: 0,
    padding: theme.spacing(0),
    ...theme.scrollbarStyles,
    borderRadius: 18,
    overflowX: "hidden",
    overflowY: "visible",
  },
  mobileSection: {
    padding: theme.spacing(1.5),
  },
  hero: {
    width: "100%",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  heroActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "& > *": {
        flex: "1 1 100%",
      },
    },
  },
  heroTitle: {
    fontWeight: 600,
    letterSpacing: "-0.01em",
  },
  filterToolbar: {
    width: "100%",
    minWidth: 0,
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    [theme.breakpoints.down("xs")]: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) auto",
    },
  },
  searchField: {
    flex: 1,
    minWidth: 0,
  },
  filterField: {
    display: "grid",
    gap: theme.spacing(0.75),
    minWidth: 0,
  },
  filterLabel: {
    fontSize: "0.78rem",
    fontWeight: 600,
    lineHeight: 1.2,
    color: theme.palette.text.secondary,
  },
  helperText: {
    opacity: 0.72,
    marginTop: theme.spacing(0.25),
  },
  tabs: {
    padding: theme.spacing(0, 1),
  },
  tableContainer: {
    width: "100%",
    minWidth: 0,
    overflowX: "auto",
  },
  rowName: {
    fontWeight: 600,
  },
  actionsCell: {
    width: 1,
    whiteSpace: "nowrap",
  },
  dangerButton: {
    color: "#b91c1c",
    borderColor: "#fecaca",
    "&:hover": {
      borderColor: "#fca5a5",
      backgroundColor: "rgba(185, 28, 28, 0.06)",
    },
  },
  mobileCards: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: theme.spacing(1.5),
  },
  contactCardMobile: {
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5),
    boxShadow: "none",
  },
  mobileCardHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    minWidth: 0,
  },
  mobileCardBody: {
    display: "grid",
    gap: theme.spacing(1),
  },
  mobileMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    alignItems: "center",
  },
  mobileMetaLabel: {
    fontSize: "0.78rem",
    opacity: 0.65,
  },
  mobileTabs: {
    padding: theme.spacing(0, 1),
  },
  // ESTILOS PARA A ABA MAPA
  legendContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    marginBottom: "20px",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    margin: "5px 10px",
  },
  legendColor: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    marginRight: "5px",
    backgroundColor: "#FFA500",
  },
  totalContactsBar: {
    backgroundColor: theme.palette.primary.main, // usa cor primária do whitelabel
    padding: "10px",
    textAlign: "center",
    color: "white",
    marginBottom: "20px",
    borderRadius: "4px",
  },
  legendCard: {
    marginBottom: "20px",
    padding: "10px",
    backgroundColor: "#e8e8e8",
    borderRadius: "8px",
    boxShadow: "none",
  },

  // ESTILO DOS CARDS DE CONTATO (MODELO DA SUA PRINT)
  contactCard: {
    backgroundColor: "#e7edf3",
    borderRadius: 8,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  cardAvatar: {
    marginRight: theme.spacing(2),
    width: 48,
    height: 48,
  },
  cardNumber: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
  cardLabel: {
    fontSize: "0.8rem",
    fontWeight: 500,
    marginTop: theme.spacing(0.5),
  },
  cardFooter: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  selectionCheckbox: {
    color: `${theme.palette.text.secondary} !important`,
    "&.Mui-checked": {
      color: `${theme.palette.primary.main} !important`,
    },
    "&.MuiCheckbox-indeterminate": {
      color: `${theme.palette.primary.main} !important`,
    },
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [searchParam, setSearchParam] = useState("");
  const [contacts, setContacts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [contactsSummary, setContactsSummary] = useState(
    buildContactsSummary()
  );
  const [sortBy, setSortBy] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);

  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedWhatsappIds, setSelectedWhatsappIds] = useState([]);
  const [walletStatus, setWalletStatus] = useState("");
  const [walletIds, setWalletIds] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const { setCurrentTicket } = useContext(TicketsContext);

  const [importWhatsappId, setImportWhatsappId] = useState();

  // SELECAO EM MASSA
  const [selectedContactIds, setSelectedContactIds] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [confirmDeleteManyOpen, setConfirmDeleteManyOpen] = useState(false);
  const [batchWalletModalOpen, setBatchWalletModalOpen] = useState(false);
  const [batchWalletUserIds, setBatchWalletUserIds] = useState([]);
  const [batchWalletLoading, setBatchWalletLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  // CONTROLE DE ABAS (CONTATOS / MAPA)
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const summaryCards = useMemo(
    () => [
      { key: "visible", label: "Visiveis", value: contacts.length },
      { key: "total", label: "Total filtrado", value: totalCount },
      { key: "active", label: "Ativos", value: contactsSummary.active },
      { key: "blocked", label: "Bloqueados", value: contactsSummary.blocked },
      { key: "wallet", label: "Com carteira", value: contactsSummary.withWallet },
    ],
    [contacts.length, contactsSummary, totalCount]
  );

  const activeAdvancedFiltersCount = [
    selectedTags.length,
    selectedWhatsappIds.length,
    walletStatus,
    walletIds.length,
  ].filter(Boolean).length;

  const appliedFilterChips = [
    selectedTags.length
      ? { key: "tags", label: `Tags: ${selectedTags.length}` }
      : null,
    selectedWhatsappIds.length
      ? { key: "whatsapps", label: `Conexoes: ${selectedWhatsappIds.length}` }
      : null,
    walletStatus
      ? {
          key: "walletStatus",
          label: `Carteira: ${
            CONTACT_WALLET_STATUS_OPTIONS.find(
              (option) => option.value === walletStatus
            )?.label || walletStatus
          }`,
        }
      : null,
    walletIds.length
      ? { key: "walletIds", label: `Responsaveis: ${walletIds.length}` }
      : null,
  ].filter(Boolean);

  const handleRequestSort = (property) => {
    const isAsc = sortBy === property && sortDirection === "asc";
    setSortBy(property);
    setSortDirection(isAsc ? "desc" : "asc");
    setPageNumber(1);
  };

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(parseInt(event.target.value, 10));
    setPageNumber(1);
  };

  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);
      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    setPageNumber(1);
    setSelectedContactIds([]);
    setIsSelectAllChecked(false);
  }, [
    searchParam,
    selectedTags,
    selectedWhatsappIds,
    walletStatus,
    walletIds,
    pageSize,
    sortBy,
    sortDirection,
  ]);

  useEffect(() => {
    if (selectedContactIds.length === 0 && batchWalletModalOpen && !batchWalletLoading) {
      setBatchWalletModalOpen(false);
      setBatchWalletUserIds([]);
    }
  }, [batchWalletLoading, batchWalletModalOpen, selectedContactIds.length]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const { data } = await api.get("/contacts/", {
            params: buildContactsQueryParams({
              searchParam,
              pageNumber,
              pageSize,
              sortBy,
              sortDirection,
              selectedTags,
              whatsappIds: selectedWhatsappIds,
              walletStatus,
              walletIds,
            }),
          });
          let contactsPayload = data.contacts;

          const contactsWithoutWalletMetadata = (data.contacts || []).filter(
            (contact) => !hasContactWalletMetadata(contact)
          );

          if (contactsWithoutWalletMetadata.length > 0) {
            const hydratedContacts = await Promise.allSettled(
              contactsWithoutWalletMetadata.map((contact) =>
                api.get(`/contacts/${contact.id}`).then((response) => response.data)
              )
            );

            const hydratedMap = new Map(
              hydratedContacts
                .filter((result) => result.status === "fulfilled" && result.value?.id)
                .map((result) => [result.value.id, result.value])
            );

            contactsPayload = (data.contacts || []).map((contact) =>
              hydratedMap.has(contact.id)
                ? { ...contact, ...hydratedMap.get(contact.id) }
                : contact
            );
          }

          setContacts(contactsPayload);
          setTotalCount(data.count || 0);
          const fallbackSummary = buildContactsSummary(contactsPayload);
          setContactsSummary({
            active: Number(data?.summary?.active ?? fallbackSummary.active) || 0,
            blocked:
              Number(data?.summary?.blocked ?? fallbackSummary.blocked) || 0,
            withWallet:
              Number(data?.summary?.withWallet ?? fallbackSummary.withWallet) || 0,
          });
          setLoading(false);

          const allCurrentContactIds = contactsPayload.map((c) => c.id);
          setSelectedContactIds((currentSelected) => {
            const newSelected = currentSelected.filter((id) =>
              allCurrentContactIds.includes(id)
            );
            setIsSelectAllChecked(
              newSelected.length === allCurrentContactIds.length &&
                allCurrentContactIds.length > 0
            );
            return newSelected;
          });
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    pageNumber,
    pageSize,
    searchParam,
    selectedTags,
    selectedWhatsappIds,
    walletStatus,
    walletIds,
    sortBy,
    sortDirection,
    refreshTrigger,
  ]);

  useEffect(() => {
    const companyId = user.companyId;
    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        setContacts((currentContacts) => {
          const contactIndex = currentContacts.findIndex(
            (contact) => contact.id === data.contact.id
          );

          if (contactIndex === -1) {
            return currentContacts;
          }

          const nextContacts = [...currentContacts];
          nextContacts[contactIndex] = {
            ...nextContacts[contactIndex],
            ...data.contact,
          };
          return nextContacts;
        });
      }

      if (data.action === "delete") {
        setContacts((currentContacts) =>
          currentContacts.filter((contact) => contact.id !== +data.contactId)
        );
        setSelectedContactIds((prevSelected) =>
          prevSelected.filter((id) => id !== +data.contactId)
        );
      }
    };
    socket.on(`company-${companyId}-contact`, onContactEvent);

    return () => {
      socket.off(`company-${companyId}-contact`, onContactEvent);
    };
  }, [socket, user.companyId]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsappIds = selecteds.map((t) => t.id);
    setSelectedWhatsappIds(whatsappIds);
  };

  const handleSelectedWalletUsers = (selectedWalletIds) => {
    setWalletIds(selectedWalletIds);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleRemoveAdvancedFilter = (key) => {
    if (key === "tags") setSelectedTags([]);
    if (key === "whatsapps") setSelectedWhatsappIds([]);
    if (key === "walletStatus") setWalletStatus("");
    if (key === "walletIds") setWalletIds([]);
    setPageNumber(1);
  };

  const handleClearAdvancedFilters = () => {
    setSelectedTags([]);
    setSelectedWhatsappIds([]);
    setWalletStatus("");
    setWalletIds([]);
    setPageNumber(1);
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      toast.success(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      if (isNoContactPermissionError(err)) {
        setDeletingContact(null);
      }
      toastError(err);
    }
    setDeletingContact(null);
  };

  const handleToggleSelectContact = (contactId) => (event) => {
    if (event.target.checked) {
      setSelectedContactIds((prevSelected) => [...prevSelected, contactId]);
    } else {
      setSelectedContactIds((prevSelected) =>
        prevSelected.filter((id) => id !== contactId)
      );
      setIsSelectAllChecked(false);
    }
  };

  const handleSelectAllContacts = (event) => {
    const checked = event.target.checked;
    setIsSelectAllChecked(checked);

    if (checked) {
      const allContactIds = contacts.map((contact) => contact.id);
      setSelectedContactIds(allContactIds);
    } else {
      setSelectedContactIds([]);
    }
  };

  const handleDeleteSelectedContacts = async () => {
    try {
      setLoading(true);
      await api.delete("/contacts/batch-delete", {
        data: { contactIds: selectedContactIds },
      });
      toast.success("Contatos selecionados deletados com sucesso!");
      setSelectedContactIds([]);
      setIsSelectAllChecked(false);
      setConfirmDeleteManyOpen(false);
      setPageNumber(1);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenBatchWalletModal = () => {
    setBatchWalletUserIds([]);
    setBatchWalletModalOpen(true);
  };

  const handleCloseBatchWalletModal = () => {
    if (batchWalletLoading) {
      return;
    }

    setBatchWalletModalOpen(false);
    setBatchWalletUserIds([]);
  };

  const handleBatchReplaceWallet = async () => {
    try {
      setBatchWalletLoading(true);
      const payload = {
        contactIds: selectedContactIds,
        ...buildContactWalletPayload(batchWalletUserIds),
      };

      const { data } = await api.put("/contacts/wallet/batch", payload);

      toast.success(
        data?.message ||
          `Carteira atualizada em ${selectedContactIds.length} contatos com sucesso.`
      );
      setBatchWalletModalOpen(false);
      setBatchWalletUserIds([]);
      setSelectedContactIds([]);
      setIsSelectAllChecked(false);
      setRefreshTrigger((currentValue) => currentValue + 1);
    } catch (err) {
      toastError(err);
    } finally {
      setBatchWalletLoading(false);
    }
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      setContacts((currentContacts) =>
        currentContacts.map((contact) =>
          contact.id === contactId ? { ...contact, active: false } : contact
        )
      );
      toast.success("Contato bloqueado");
    } catch (err) {
      if (isNoContactPermissionError(err)) {
        setBlockingContact(null);
      }
      toastError(err);
    }
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      setContacts((currentContacts) =>
        currentContacts.map((contact) =>
          contact.id === contactId ? { ...contact, active: true } : contact
        )
      );
      toast.success("Contato desbloqueado");
    } catch (err) {
      if (isNoContactPermissionError(err)) {
        setUnBlockingContact(null);
      }
      toastError(err);
    }
    setUnBlockingContact(null);
  };

  const onSave = (whatsappId) => {
    setImportWhatsappId(whatsappId);
  };

  const handleimportContact = async () => {
    setImportContactModalOpen(false);

    try {
      await api.post("/contacts/import", { whatsappId: importWhatsappId });
      history.go(0);
      setImportContactModalOpen(false);
    } catch (err) {
      toastError(err);
      setImportContactModalOpen(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  // ===== FUNCAO PARA CONTAR CONTATOS POR ESTADO (USADA NO MAPA) =====
  const countContactsByState = () => {
    const stateCounts = {};

    contacts.forEach((contact) => {
      const number = contact.number;
      if (number && number.length > 4) {
        const ddd = number.substring(2, 4);
        if (dddList[ddd]) {
          const state = dddList[ddd];
          if (!stateCounts[state]) {
            stateCounts[state] = 0;
          }
          stateCounts[state]++;
        } else {
          if (!stateCounts["Outros"]) {
            stateCounts["Outros"] = 0;
          }
          stateCounts["Outros"]++;
        }
      }
    });

    return stateCounts;
  };

  const stateCounts = countContactsByState();

  return (
    <MainContainer className={classes.mainContainer} fullWidth>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>
      <ContactBatchWalletModal
        open={batchWalletModalOpen}
        onClose={handleCloseBatchWalletModal}
        onConfirm={handleBatchReplaceWallet}
        loading={batchWalletLoading}
        selectedCount={selectedContactIds.length}
        value={batchWalletUserIds}
        onChange={setBatchWalletUserIds}
      />

      <ConfirmationModal
        title={
          deletingContact
            ? `${i18n.t(
                "contacts.confirmationModal.deleteTitle"
              )} ${deletingContact.name}?`
            : blockingContact
            ? `Bloquear Contato ${blockingContact.name}?`
            : unBlockingContact
            ? `Desbloquear Contato ${unBlockingContact.name}?`
            : ImportContacts
            ? `${i18n.t("contacts.confirmationModal.importTitlte")}`
            : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
        }
        onSave={onSave}
        isCellPhone={ImportContacts}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={(e) =>
          deletingContact
            ? handleDeleteContact(deletingContact.id)
            : blockingContact
            ? handleBlockContact(blockingContact.id)
            : unBlockingContact
            ? handleUnBlockContact(unBlockingContact.id)
            : ImportContacts
            ? handleimportContact()
            : handleImportExcel()
        }
      >
        {exportContact
          ? `${i18n.t("contacts.confirmationModal.exportContact")}`
          : deletingContact
          ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
          : blockingContact
          ? `${i18n.t("contacts.confirmationModal.blockContact")}`
          : unBlockingContact
          ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
          : ImportContacts
          ? `Escolha de qual conexão deseja importar`
          : `${i18n.t(
              "contactListItems.confirmationModal.importMessage"
            )}`}
      </ConfirmationModal>

      <ConfirmationModal
        title={`Tem certeza que deseja deletar ${selectedContactIds.length} contatos selecionados?`}
        open={confirmDeleteManyOpen}
        onClose={() => setConfirmDeleteManyOpen(false)}
        onConfirm={handleDeleteSelectedContacts}
      >
        Essa ação é irreversível.
      </ConfirmationModal>

      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      <div className={classes.contentStack}>
        <Box className={classes.hero}>
          <Box>
            <Typography variant="h6" className={classes.heroTitle}>
              {i18n.t("contacts.title")}
            </Typography>
          </Box>

          <Box className={classes.heroActions}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenContactModal}
            >
              {i18n.t("contacts.buttons.add")}
            </Button>

            <PopupState variant="popover" popupId="contacts-import-menu">
              {(popupState) => (
                <React.Fragment>
                  <Button
                    variant="outlined"
                    color="primary"
                    {...bindTrigger(popupState)}
                  >
                    Importar / Exportar
                    <ArrowDropDown />
                  </Button>
                  <Menu {...bindMenu(popupState)}>
                    <MenuItem
                      onClick={() => {
                        setConfirmOpen(true);
                        setImportContacts(true);
                        popupState.close();
                      }}
                    >
                      <ContactPhone
                        fontSize="small"
                        color="primary"
                        style={{ marginRight: 10 }}
                      />
                      {i18n.t("contacts.menu.importYourPhone")}
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setImportContactModalOpen(true);
                        popupState.close();
                      }}
                    >
                      <Backup
                        fontSize="small"
                        color="primary"
                        style={{ marginRight: 10 }}
                      />
                      {i18n.t("contacts.menu.importToExcel")}
                    </MenuItem>
                  </Menu>
                </React.Fragment>
              )}
            </PopupState>

            {selectedContactIds.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenBatchWalletModal}
                disabled={loading || batchWalletLoading}
              >
                Definir carteira ({selectedContactIds.length})
              </Button>
            )}

            {selectedContactIds.length > 0 && (
              <Button
                variant="outlined"
                onClick={() => setConfirmDeleteManyOpen(true)}
                disabled={loading || batchWalletLoading}
                className={classes.dangerButton}
              >
                Deletar selecionados ({selectedContactIds.length})
              </Button>
            )}
          </Box>
        </Box>

        <MetricsStrip ariaLabel="Indicadores de contatos" items={summaryCards} />

        <Paper className={classes.filterToolbar} elevation={0}>
          <TextField
            className={classes.searchField}
            fullWidth
            placeholder={i18n.t("contacts.searchPlaceholder")}
            type="search"
            value={searchParam}
            onChange={handleSearch}
            variant="outlined"
            size="small"
            inputProps={{ "aria-label": "Pesquisar contatos" }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
          <FilterButton
            count={activeAdvancedFiltersCount}
            open={Boolean(filterAnchorEl)}
            controls="contacts-filters"
            onClick={(event) => setFilterAnchorEl(event.currentTarget)}
          />
        </Paper>

        <FilterPopover
          id="contacts-filters"
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={() => setFilterAnchorEl(null)}
          onClear={handleClearAdvancedFilters}
          clearDisabled={!activeAdvancedFiltersCount}
          onApply={() => setFilterAnchorEl(null)}
        >
          <Box className={classes.filterField}>
            <Typography className={classes.filterLabel}>Tags</Typography>
            <TagsFilter
              onFiltered={handleSelectedTags}
              value={selectedTags}
              containerStyle={{ padding: 0 }}
              placeholder="Todas as tags"
              limitTags={1}
            />
          </Box>
          <Box className={classes.filterField}>
            <Typography className={classes.filterLabel}>Conexoes</Typography>
            <WhatsappsFilter
              onFiltered={handleSelectedWhatsapps}
              value={selectedWhatsappIds}
              containerStyle={{ padding: 0 }}
              placeholder="Todas as conexoes"
              limitTags={1}
            />
          </Box>
          <Box className={classes.filterField}>
            <Typography className={classes.filterLabel}>Carteira</Typography>
            <TextField
              select
              fullWidth
              value={walletStatus}
              onChange={(event) => setWalletStatus(event.target.value)}
              variant="outlined"
              size="small"
            >
              {CONTACT_WALLET_STATUS_OPTIONS.map((option) => (
                <MenuItem key={option.value || "all-wallet-status"} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box className={classes.filterField}>
            <Typography className={classes.filterLabel}>
              Responsaveis da carteira
            </Typography>
            <ContactWalletField
              value={walletIds}
              onChange={handleSelectedWalletUsers}
              disabled={loading}
              label={null}
              placeholder="Todos os responsaveis"
              helperText={null}
              margin="none"
              size="small"
              limitTags={2}
            />
          </Box>
          <Typography variant="body2" className={classes.helperText}>
            Combine conexoes com Sem carteira para encontrar contatos publicos.
          </Typography>
        </FilterPopover>

        <AppliedFiltersBar
          filters={appliedFilterChips}
          onRemove={handleRemoveAdvancedFilter}
          onClearAll={handleClearAdvancedFilters}
        />

        {importContactModalOpen && (
          <ContactImportWpModal
            isOpen={importContactModalOpen}
            handleClose={() => setImportContactModalOpen(false)}
            selectedTags={selectedTags}
            hideNum={hideNum}
            userProfile={user.profile}
          />
        )}

        {/* ABAS CONTATOS / MAPA */}
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="abas-contatos-mapa"
          variant={isMobile ? "fullWidth" : "standard"}
          className={classes.mobileTabs}
        >
          <Tab label="Contatos" />
          <Tab label="Mapa" />
        </Tabs>

        <Paper
          className={classes.mainPaper}
          variant="outlined"
        >
          <>
            <input
              style={{ display: "none" }}
              id="upload"
              name="file"
              type="file"
              accept=".xls,.xlsx"
              onChange={() => {
                setConfirmOpen(true);
              }}
              ref={fileUploadRef}
            />
          </>

          {/* ABA CONTATOS EM TABELA */}
          {tabValue === 0 && (
            <div>
            {isMobile ? (
              <Box className={classes.mobileSection}>
                <div className={classes.mobileCards}>
                  {contacts.map((contact) => (
                    <Paper key={contact.id} className={classes.contactCardMobile} elevation={0}>
                      <Box className={classes.mobileCardHeader}>
                        <Checkbox
                          className={classes.selectionCheckbox}
                          checked={selectedContactIds.includes(contact.id)}
                          onChange={handleToggleSelectContact(contact.id)}
                          inputProps={{
                            "aria-label": `Selecionar contato ${contact.name}`,
                          }}
                        />
                        <Avatar
                          src={`${contact?.urlPicture}`}
                          className={classes.cardAvatar}
                        />
                        <Box minWidth={0} flex={1}>
                          <Typography variant="body2" className={classes.rowName} noWrap>
                            {contact.name || "-"}
                          </Typography>
                          <Typography variant="body2" color="textSecondary" noWrap>
                            {contact.email || "Sem e-mail"}
                          </Typography>
                        </Box>
                        <RowActionsMenu
                          buttonTitle="Acoes do contato"
                          actions={[
                            {
                              key: "open-ticket",
                              label:
                                contact.channel === "instagram"
                                  ? "Abrir atendimento no Instagram"
                                  : contact.channel === "facebook"
                                    ? "Abrir atendimento no Facebook"
                                    : "Abrir atendimento no WhatsApp",
                              icon:
                                contact.channel === "instagram"
                                  ? Instagram
                                  : contact.channel === "facebook"
                                    ? Facebook
                                    : WhatsApp,
                              disabled: !contact.active,
                              onClick: () => {
                                setContactTicket(contact);
                                setNewTicketModalOpen(true);
                              },
                            },
                            {
                              key: "edit",
                              label: "Editar contato",
                              icon: EditIcon,
                              onClick: () => hadleEditContact(contact.id),
                            },
                            {
                              key: "toggle-block",
                              label: contact.active
                                ? "Bloquear contato"
                                : "Desbloquear contato",
                              icon: contact.active ? BlockIcon : CheckCircleIcon,
                              onClick: () => {
                                setConfirmOpen(true);
                                if (contact.active) {
                                  setBlockingContact(contact);
                                } else {
                                  setUnBlockingContact(contact);
                                }
                              },
                            },
                            {
                              key: "delete",
                              label: "Excluir contato",
                              icon: DeleteOutlineIcon,
                              hidden: !user || !["admin", "super"].includes(user.profile),
                              onClick: () => {
                                setConfirmOpen(true);
                                setDeletingContact(contact);
                              },
                            },
                          ]}
                        />
                      </Box>

                      <Box className={classes.mobileCardBody}>
                        <div className={classes.mobileMetaRow}>
                          <Typography className={classes.mobileMetaLabel}>Numero</Typography>
                          <Typography variant="body2">
                            {enableLGPD && hideNum && user.profile === "user"
                              ? contact.isGroup
                                ? contact.number
                                : formatSerializedId(contact?.number) === null
                                ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2)
                                : formatSerializedId(contact?.number)?.slice(0, -6) +
                                  "**-**" +
                                  contact?.number?.slice(-2)
                              : contact.isGroup
                              ? contact.number
                              : formatSerializedId(contact?.number)}
                          </Typography>
                        </div>
                        <div className={classes.mobileMetaRow}>
                          <Typography className={classes.mobileMetaLabel}>Canal</Typography>
                          <Chip
                            size="small"
                            label={contact?.whatsapp?.name || contact.channel || "-"}
                            style={{ backgroundColor: "#e0f2fe", color: "#075985" }}
                          />
                        </div>
                        <div className={classes.mobileMetaRow}>
                          <Typography className={classes.mobileMetaLabel}>Status</Typography>
                          {contact.active ? (
                            <Chip
                              size="small"
                              icon={<CheckCircleIcon style={{ color: "#166534" }} />}
                              label="Ativo"
                              style={{ backgroundColor: "#dcfce7", color: "#166534" }}
                            />
                          ) : (
                            <Chip
                              size="small"
                              icon={<CancelIcon style={{ color: "#991b1b" }} />}
                              label="Bloqueado"
                              style={{ backgroundColor: "#fee2e2", color: "#991b1b" }}
                            />
                          )}
                        </div>
                        <div className={classes.mobileMetaRow}>
                          <Typography className={classes.mobileMetaLabel}>Carteira</Typography>
                          <ContactWalletInfo contact={contact} compact />
                        </div>
                      </Box>
                    </Paper>
                  ))}
                </div>
              </Box>
            ) : (
            <TableContainer className={classes.tableContainer}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        className={classes.selectionCheckbox}
                        checked={isSelectAllChecked}
                        onChange={handleSelectAllContacts}
                        inputProps={{ "aria-label": "Selecionar todos os contatos" }}
                      />
                    </TableCell>
                    <TableCell sortDirection={sortBy === "name" ? sortDirection : false}>
                      <TableSortLabel
                        active={sortBy === "name"}
                        direction={sortBy === "name" ? sortDirection : "asc"}
                        onClick={() => handleRequestSort("name")}
                      >
                        {i18n.t("contacts.table.name")}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={sortBy === "number" ? sortDirection : false}>
                      <TableSortLabel
                        active={sortBy === "number"}
                        direction={sortBy === "number" ? sortDirection : "asc"}
                        onClick={() => handleRequestSort("number")}
                      >
                        Numero
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={sortBy === "email" ? sortDirection : false}>
                      <TableSortLabel
                        active={sortBy === "email"}
                        direction={sortBy === "email" ? sortDirection : "asc"}
                        onClick={() => handleRequestSort("email")}
                      >
                        {i18n.t("contacts.table.email")}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell sortDirection={sortBy === "channel" ? sortDirection : false}>
                      <TableSortLabel
                        active={sortBy === "channel"}
                        direction={sortBy === "channel" ? sortDirection : "asc"}
                        onClick={() => handleRequestSort("channel")}
                      >
                        Canal
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Carteira</TableCell>
                    <TableCell sortDirection={sortBy === "active" ? sortDirection : false}>
                      <TableSortLabel
                        active={sortBy === "active"}
                        direction={sortBy === "active" ? sortDirection : "asc"}
                        onClick={() => handleRequestSort("active")}
                      >
                        Status
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="right" className={classes.actionsCell}>
                      {i18n.t("contacts.table.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contacts.map((contact) => (
                    <TableRow hover key={contact.id}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          className={classes.selectionCheckbox}
                          checked={selectedContactIds.includes(contact.id)}
                          onChange={handleToggleSelectContact(contact.id)}
                          inputProps={{
                            "aria-label": `Selecionar contato ${contact.name}`,
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap={12}>
                          <Avatar
                            src={`${contact?.urlPicture}`}
                            className={classes.cardAvatar}
                          />
                          <Box>
                            <Typography variant="body2" className={classes.rowName}>
                              {contact.name || "-"}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              ID #{contact.id}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" className={classes.cardNumber}>
                          {enableLGPD && hideNum && user.profile === "user"
                            ? contact.isGroup
                              ? contact.number
                              : formatSerializedId(contact?.number) === null
                              ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2)
                              : formatSerializedId(contact?.number)?.slice(0, -6) +
                                "**-**" +
                                contact?.number?.slice(-2)
                            : contact.isGroup
                            ? contact.number
                            : formatSerializedId(contact?.number)}
                        </Typography>
                      </TableCell>
                      <TableCell>{contact.email || "-"}</TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={contact?.whatsapp?.name || contact.channel || "-"}
                          style={{ backgroundColor: "#e0f2fe", color: "#075985" }}
                        />
                      </TableCell>
                      <TableCell>
                        <ContactWalletInfo contact={contact} compact />
                      </TableCell>
                      <TableCell>
                        {contact.active ? (
                          <Chip
                            size="small"
                            icon={<CheckCircleIcon style={{ color: "#166534" }} />}
                            label="Ativo"
                            style={{ backgroundColor: "#dcfce7", color: "#166534" }}
                          />
                        ) : (
                          <Chip
                            size="small"
                            icon={<CancelIcon style={{ color: "#991b1b" }} />}
                            label="Bloqueado"
                            style={{ backgroundColor: "#fee2e2", color: "#991b1b" }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="right" className={classes.actionsCell}>
                        <RowActionsMenu
                          buttonTitle="Acoes do contato"
                          actions={[
                            {
                              key: "open-ticket",
                              label:
                                contact.channel === "instagram"
                                  ? "Abrir atendimento no Instagram"
                                  : contact.channel === "facebook"
                                    ? "Abrir atendimento no Facebook"
                                    : "Abrir atendimento no WhatsApp",
                              icon:
                                contact.channel === "instagram"
                                  ? Instagram
                                  : contact.channel === "facebook"
                                    ? Facebook
                                    : WhatsApp,
                              disabled: !contact.active,
                              onClick: () => {
                                setContactTicket(contact);
                                setNewTicketModalOpen(true);
                              },
                            },
                            {
                              key: "edit",
                              label: "Editar contato",
                              icon: EditIcon,
                              onClick: () => hadleEditContact(contact.id),
                            },
                            {
                              key: "toggle-block",
                              label: contact.active
                                ? "Bloquear contato"
                                : "Desbloquear contato",
                              icon: contact.active ? BlockIcon : CheckCircleIcon,
                              onClick: () => {
                                setConfirmOpen(true);
                                if (contact.active) {
                                  setBlockingContact(contact);
                                } else {
                                  setUnBlockingContact(contact);
                                }
                              },
                            },
                            {
                              key: "delete",
                              label: "Excluir contato",
                              icon: DeleteOutlineIcon,
                              hidden: !user || !["admin", "super"].includes(user.profile),
                              onClick: () => {
                                setConfirmOpen(true);
                                setDeletingContact(contact);
                              },
                            },
                          ]}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            )}

            {loading && (
              <Box p={2}>
                <TableRowSkeleton avatar columns={6} />
              </Box>
            )}

            {!loading && contacts.length === 0 && (
              <Box p={4} textAlign="center">
                <Typography variant="h6">
                  Nenhum contato encontrado
                </Typography>
                <Typography variant="body2" className={classes.helperText}>
                  Ajuste os filtros ou cadastre um novo contato para continuar.
                </Typography>
              </Box>
            )}

            <TablePagination
              component="div"
              count={totalCount}
              page={Math.max(pageNumber - 1, 0)}
              onPageChange={handleChangePage}
              rowsPerPage={pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 25, 50, 100]}
              labelRowsPerPage="Itens por pagina"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : to}`
              }
            />
          </div>
        )}

        {/* ABA MAPA */}
        {tabValue === 1 && (
          <>
            <Box className={classes.totalContactsBar}>
              <Typography variant="h6">
                Total de Contatos por Estado: {contacts.length}
              </Typography>
            </Box>

            <Box p={3}>
              <Card className={classes.legendCard}>
                <CardContent>
                  <Box className={classes.legendContainer}>
                    {Object.entries(stateCounts).map(([state, count]) => (
                      <Box key={state} className={classes.legendItem}>
                        <div className={classes.legendColor} />
                        <Typography variant="body2">
                          {state}: {count} contato(s)
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </CardContent>
              </Card>

              <ComposableMap
                projection="geoMercator"
                projectionConfig={{
                  scale: 600,
                  center: [-53, -15],
                }}
                style={{ width: "100%", height: "auto" }}
              >
                <Geographies geography={geoUrl}>
                  {({ geographies }) =>
                    geographies.map((geo) => {
                      const state = geo.properties.name;
                      const count = stateCounts[state] || 0;

                      return (
                        <Geography
                          key={geo.rsmKey}
                          geography={geo}
                          fill={count > 0 ? "#FFA500" : "#EAEAEC"}
                          stroke="#D6D6DA"
                          style={{
                            hover: {
                              fill: "#FFA500",
                              stroke: "#D6D6DA",
                            },
                          }}
                        />
                      );
                    })
                  }
                </Geographies>
                {markers.map(({ name, coordinates, markerOffset }) => (
                  <Marker key={name} coordinates={coordinates}>
                    <circle
                      r={5}
                      fill="#F00"
                      stroke="#fff"
                      strokeWidth={1}
                    />
                    <text
                      textAnchor="middle"
                      y={markerOffset}
                      style={{
                        fontFamily: "system-ui",
                        fill: "#5D5A6D",
                        fontSize: "12px",
                      }}
                    >
                      {name}
                    </text>
                  </Marker>
                ))}
              </ComposableMap>
            </Box>
          </>
          )}
        </Paper>
      </div>
    </MainContainer>
  );
};

export default Contacts;
